'use strict';

var config = require('widget/scripts/lib/config/main'),
    messaging = require('shared/messaging'),

    messageListeners = [];

module.exports = {
    bootstrap: bootstrapGlobalMessageListener,
    registerListener: registerListener,
    unregisterListener: unregisterListener
};

function bootstrapGlobalMessageListener() {
    window.addEventListener('message', _messageListener, false);
}

function registerListener(widgetId, messageTitle, callback, useOnce) {

    messageListeners.push({
        widgetId: widgetId,
        messageTitle: messageTitle,
        callback: callback,
        useOnce: useOnce || false
    });
}

function unregisterListener(widgetId, messageTitle, callback) {

    messageListeners = messageListeners.filter(function (messageListener) {
        return !(
            messageListener.widgetId === widgetId &&
            (messageListener.messageTitle === messageTitle || messageTitle === '**') &&
            (messageListener.callback === callback || !callback)
        );
    });
}

function _messageListener(event) {

    if (_isAcceptable()) {
        _informListeners(event.data, event.ports[0]);
    }

    function _isAcceptable() {
        return config.SERVICE_URL.replace(/^https?:/i, '').indexOf(event.origin.replace(/^https?:/i, '')) === 0 && messaging.isValidMessage(event.data);
    }
}

function _informListeners(incomingMessage, channel) {

    messageListeners.forEach(function (messageListener) {

        if (_isAddressedTo(messageListener.widgetId, incomingMessage.widgetId) && _listenerAcceptsThisTitle(messageListener.messageTitle, incomingMessage.messageTitle)) {
            messageListener.callback(incomingMessage, channel);

            if (messageListener.useOnce) {
                unregisterListener(messageListener.widgetId, messageListener.messageTitle, messageListener.callback);
            }
        }

    });

    function _isAddressedTo(listenerWidgetId, messageTargetWidgetId) {
        return listenerWidgetId === messageTargetWidgetId;
    }

    function _listenerAcceptsThisTitle(listenerAcceptedTitle, messageTitle) {
        return listenerAcceptedTitle === messageTitle || listenerAcceptedTitle === '*';
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/globalMessageListeners.js
// module id = 3
// module chunks = 0 1